export const CREATE_LEAVE_FORM_CALL_ATTEMPT = `
  mutation createLeaveFormCallAttempt($tenant_id: Int!, $input: CreateLeaveFormCallAttemptInput!) {
    createLeaveFormCallAttempt(tenant_id: $tenant_id, input: $input) {
      __typename
      ... on LeaveFormCallAttempt {
        id
        leave_form_id
        attempt_number
        status
        call_date
        comment
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
